import React from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';

// Submenu 컴포넌트를 같은 파일 내에서 정의
const Submenu = ({ item, toggleSidebar }) => (
  <Link
    to={item.path}
    className="submenu-item"
    onClick={toggleSidebar}
  >
    {item.name}
  </Link>
);

function MenuItem({ title, isActive, onClick, submenus, toggleSidebar }) {
  return (
    <div className="menu-item">
      <div className="menu-title" onClick={onClick}>
        <span>{title}</span>
        <span className="menu-icon">
          {isActive ? <FaChevronUp /> : <FaChevronDown />}
        </span>
      </div>
      {isActive && (
        <div className="submenu">
          {submenus.map((item, index) => (
            <Submenu
              key={index}
              item={item}
              toggleSidebar={toggleSidebar}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default MenuItem;